import { Button, Clickable, Dropdown } from "artisn-ui-react";
import React from "react";

import Styles, { DropdownOverlayStyled } from "./DropdownOptions.styles";
import { DropdownOptionsProps as Props } from "./DropdownOptions.types";
import useI18n from "hooks/useI18n";

import MoreVerticalSVG from "../../../../public/assets/images/more-vertical.svg";

const DropdownOptions: React.FC<Props> = props => {
  const t = useI18n();
  const { className, onEdit, onDelete, onDefault, isFixed = true } = props;

  const overlayNode = (
    <DropdownOverlayStyled className="DropdownOverlay" isFixed={isFixed}>
      {onDefault ? (
        <Button
          className="DropdownOverlay__option"
          type="LINK"
          onClick={onDefault}
        >
          {t.profile.address.predetermined}
        </Button>
      ) : null}
      {onEdit ? (
        <Button
          className="DropdownOverlay__option"
          type="LINK"
          onClick={onEdit}
        >
          {t.common.edit}
        </Button>
      ) : null}
      {onDelete ? (
        <Button
          className="DropdownOverlay__option DropdownOverlay__option--red"
          type="LINK"
          onClick={onDelete}
        >
          {t.common.delete}
        </Button>
      ) : null}
    </DropdownOverlayStyled>
  );

  return (
    <Styles className={`DropdownOptions ${className}`}>
      <Dropdown overlay={overlayNode} target={["click"]} position="right">
        <Clickable onClick={() => {}}>
          <MoreVerticalSVG />
        </Clickable>
      </Dropdown>
    </Styles>
  );
};

DropdownOptions.defaultProps = {
  className: ""
};

export default DropdownOptions;
